(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boxsmith-bundle-customizations"] && !Shopify.designMode) return;
  try {
    (() => {
    const templateClass = 'template-product-bundle';
    const normalizeText = (value) => value.replace(/\s+/g, ' ').trim();
    const normalizeKey = (value) => normalizeText(value).toLocaleLowerCase();

    const getTranslations = () => {
      const source = document.querySelector('[data-boxsmith-bundle-translations]');

      if (!source) {
        return null;
      }

      return {
        selectionCount: source.dataset.selectionCount,
        soldOut: source.dataset.soldOut,
        outOfStock: source.dataset.outOfStock,
        unavailable: source.dataset.unavailable,
        addToCart: source.dataset.addToCart,
        buyNow: source.dataset.buyNow,
        selectOptions: source.dataset.selectOptions,
        youSave: source.dataset.youSave,
        onePerProduct: source.dataset.onePerProduct
      };
    };

    const getCatalog = () => {
      const source = document.querySelector('[data-boxsmith-variant-images]');

      if (!source) {
        return [];
      }

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return [];
      }
    };

    const getText = (element) => {
      if (element instanceof HTMLInputElement) {
        return normalizeText(element.value);
      }

      return normalizeText(element.textContent || '');
    };

    const setText = (node, value) => {
      if (node.nodeValue !== value) {
        node.nodeValue = value;
      }
    };

    const translateTextNode = (node, translations) => {
      const text = normalizeText(node.nodeValue || '');
      const selectionMatch = text.match(/^(\d+)\s+of\s+(\d+)\s+selected$/i);

      if (selectionMatch) {
        setText(
          node,
          translations.selectionCount
            .replace('[current]', selectionMatch[1])
            .replace('[total]', selectionMatch[2])
        );
        return;
      }

      const savingsMatch = text.match(/^you save(?:\s+(.+))?$/i);

      if (savingsMatch) {
        setText(node, savingsMatch[1] ? `${translations.youSave} ${savingsMatch[1]}` : translations.youSave);
        return;
      }

      const exactTranslations = new Map([
        ['sold out', translations.soldOut],
        ['out of stock', translations.outOfStock],
        ['unavailable', translations.unavailable],
        ['add to cart', translations.addToCart],
        ['buy now', translations.buyNow],
        ['select options', translations.selectOptions]
      ]);
      const translation = exactTranslations.get(text.toLowerCase());

      if (translation) {
        setText(node, translation);
      }
    };

    const hideBoxsmithBranding = (root) => {
      const candidates = root.querySelectorAll('a, span, p, small');

      candidates.forEach((element) => {
        if (!/^power(?:ed)? by boxsmith$/i.test(getText(element))) {
          return;
        }

        const branding = element.closest('a[href*="boxsmith" i]') || element;
        branding.hidden = true;
        branding.setAttribute('aria-hidden', 'true');
      });
    };

    const stylePrimaryButton = (root) => {
      const buttons = root.querySelectorAll('button, input[type="submit"], [role="button"], a');

      buttons.forEach((button) => {
        const text = getText(button);

        if (text === 'Probierset in den Warenkorb' || /^add to cart$/i.test(text)) {
          button.classList.add('button', 'button--primary', 'boxsmith-bundle-primary-button');
        }
      });
    };

    const isIncrementControl = (element) => {
      if (!(element instanceof Element)) {
        return false;
      }

      const label = normalizeText([
        element.textContent || '',
        element.getAttribute('aria-label') || '',
        element.getAttribute('title') || ''
      ].join(' '));

      return /^\+$/.test(normalizeText(element.textContent || '')) || /increase(?: product)? quantity|increment(?: product)? quantity|add one|^plus$/i.test(label);
    };

    const isDecrementControl = (element) => {
      if (!(element instanceof Element)) {
        return false;
      }

      const label = normalizeText([
        element.textContent || '',
        element.getAttribute('aria-label') || '',
        element.getAttribute('title') || ''
      ].join(' '));

      return /^[\u2212-]$/.test(normalizeText(element.textContent || '')) || /decrease(?: product)? quantity|decrement(?: product)? quantity|remove one|^minus$/i.test(label);
    };

    const styleQuantityControls = (root) => {
      const controls = root.querySelectorAll('button, [role="button"]');

      controls.forEach((control) => {
        if (isIncrementControl(control) || isDecrementControl(control)) {
          control.dataset.popteeQuantityControl = 'true';
        }
      });
    };

    const getControlQuantity = (control) => {
      const group = control.parentElement;

      if (!group) {
        return null;
      }

      const input = group.querySelector('input[type="number"], input[name*="quantity" i]');

      if (input && /^\d+$/.test(input.value)) {
        return Number.parseInt(input.value, 10);
      }

      const quantityElement = Array.from(group.children).find((element) => {
        if (element === control) {
          return false;
        }

        return /^\d+$/.test(normalizeText(element.textContent || ''));
      });

      return quantityElement ? Number.parseInt(normalizeText(quantityElement.textContent || ''), 10) : null;
    };

    const limitProductQuantities = (root, translations) => {
      const controls = root.querySelectorAll('button, [role="button"]');

      controls.forEach((control) => {
        if (!isIncrementControl(control)) {
          return;
        }

        const quantity = getControlQuantity(control);

        if (quantity !== null && quantity >= 1) {
          control.dataset.popteeMaxOne = 'true';
          control.setAttribute('aria-disabled', 'true');
          control.setAttribute('title', translations.onePerProduct);

          if (control instanceof HTMLButtonElement && !control.disabled) {
            control.dataset.popteeDisabledByLimit = 'true';
            control.disabled = true;
          }

          return;
        }

        if (quantity === 0 && control.dataset.popteeMaxOne === 'true') {
          delete control.dataset.popteeMaxOne;
          control.removeAttribute('aria-disabled');

          if (control.getAttribute('title') === translations.onePerProduct) {
            control.removeAttribute('title');
          }

          if (control instanceof HTMLButtonElement && control.dataset.popteeDisabledByLimit === 'true') {
            control.disabled = false;
            delete control.dataset.popteeDisabledByLimit;
          }
        }
      });
    };

    const getNumericAttribute = (element, names) => {
      for (const name of names) {
        const value = element.getAttribute(name);

        if (value && /^\d+$/.test(value)) {
          return Number.parseInt(value, 10);
        }
      }

      return null;
    };

    const getCardVariantId = (card) => {
      const names = ['data-variant-id', 'data-variant_id', 'data-variantid', 'data-selected-variant-id'];
      const elements = [card, ...card.querySelectorAll(names.map((name) => `[${name}]`).join(', '))];

      for (const element of elements) {
        const variantId = getNumericAttribute(element, names);

        if (variantId) {
          return variantId;
        }
      }

      const variantInput = card.querySelector('input[name="id"], input[name*="variant" i], select[name="id"]');

      if (variantInput && /^\d+$/.test(variantInput.value)) {
        return Number.parseInt(variantInput.value, 10);
      }

      const variantLink = card.querySelector('a[href*="variant="]');
      const variantMatch = variantLink?.href.match(/[?&]variant=(\d+)/i);
      return variantMatch ? Number.parseInt(variantMatch[1], 10) : null;
    };

    const getCardPrice = (card) => {
      const priceMatch = getText(card).match(/(?:^|\s)(\d{1,3}(?:[.\s]\d{3})*,\d{2})\s*€/);

      if (!priceMatch) {
        return null;
      }

      return Number.parseInt(priceMatch[1].replace(/[.\s]/g, '').replace(',', ''), 10);
    };

    const findVariant = (card, product) => {
      const variantId = getCardVariantId(card);

      if (variantId) {
        const exactVariant = product.variants.find((variant) => variant.id === variantId);

        if (exactVariant) {
          return exactVariant;
        }
      }

      const cardPrice = getCardPrice(card);

      if (cardPrice !== null) {
        const priceMatches = product.variants.filter((variant) => variant.price === cardPrice && variant.image);

        if (priceMatches.length === 1) {
          return priceMatches[0];
        }
      }

      const probeVariant = product.variants.find((variant) => /(?:^|\W)probe(?:\W|$)|10\s*g/i.test(variant.title) && variant.image);
      return probeVariant || product.variants.find((variant) => variant.image) || null;
    };

    const findProductCard = (image, catalog) => {
      const imageLabel = normalizeKey(`${image.alt || ''} ${image.getAttribute('title') || ''}`);
      let candidate = image.parentElement;

      for (let depth = 0; candidate && depth < 9; depth += 1) {
        const candidateText = normalizeKey(candidate.textContent || '');
        const matchingProduct = catalog
          .filter((product) => candidateText.includes(normalizeKey(product.title)) || imageLabel.includes(normalizeKey(product.title)))
          .sort((first, second) => second.title.length - first.title.length)[0];

        if (matchingProduct && candidateText.includes(normalizeKey(matchingProduct.title))) {
          return { card: candidate, product: matchingProduct };
        }

        candidate = candidate.parentElement;
      }

      return null;
    };

    const applyVariantImages = (root, catalog) => {
      if (!catalog.length) {
        return;
      }

      root.querySelectorAll('img').forEach((image) => {
        const match = findProductCard(image, catalog);

        if (!match) {
          return;
        }

        const variant = findVariant(match.card, match.product);

        if (!variant?.image) {
          return;
        }

        if (image.getAttribute('src') !== variant.image) {
          image.removeAttribute('srcset');
          image.setAttribute('src', variant.image);
        }

        image.dataset.popteeVariantImage = String(variant.id);
      });
    };

    const updateBoxsmith = () => {
      if (!document.body.classList.contains(templateClass)) {
        return;
      }

      const translations = getTranslations();
      const root = document.querySelector('[id^="shopify-section-"][id$="__1785674675dbe55e7b"]');

      if (!translations || !root) {
        return;
      }

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        translateTextNode(node, translations);
        node = walker.nextNode();
      }

      hideBoxsmithBranding(root);
      stylePrimaryButton(root);
      styleQuantityControls(root);
      limitProductQuantities(root, translations);
      applyVariantImages(root, getCatalog());
    };

    let scheduled = false;
    const scheduleUpdate = () => {
      if (scheduled) {
        return;
      }

      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateBoxsmith();
      });
    };

    const preventAdditionalProduct = (event) => {
      if (!document.body.classList.contains(templateClass)) {
        return;
      }

      const control = event.target instanceof Element ? event.target.closest('button, [role="button"]') : null;

      if (!control || !isIncrementControl(control)) {
        return;
      }

      const quantity = getControlQuantity(control);

      if (quantity !== null && quantity >= 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };

    const updateAfterQuantityChange = (event) => {
      const control = event.target instanceof Element ? event.target.closest('button, [role="button"]') : null;

      if (control && (isIncrementControl(control) || isDecrementControl(control))) {
        scheduleUpdate();
      }
    };

    const initialize = () => {
      if (!document.body.classList.contains(templateClass)) {
        return;
      }

      scheduleUpdate();

      const root = document.querySelector('[id^="shopify-section-"][id$="__1785674675dbe55e7b"]');
      if (root) {
        new MutationObserver(scheduleUpdate).observe(root, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      document.addEventListener('click', preventAdditionalProduct, true);
      document.addEventListener('click', updateAfterQuantityChange);
      document.addEventListener('input', scheduleUpdate);
      document.addEventListener('change', scheduleUpdate);
      document.addEventListener('shopify:section:load', scheduleUpdate);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
